export const types = {
    SET_GET_PAYMENTS: '[PAYMENTS] SET GET PAYMENTS',
    SET_GET_PAYMENTS_BY_ID: '[PAYMENTS] SET GET PAYMENTS BY ID'
}